import { getLBannerWidthScale, getLBannerHeightScale } from '../../../../video/lBanner/lBanner.utils';
import { SCREEN_HEIGHT, SCREEN_WIDTH, getScreenSize } from '../../../../tornado/utils/sizes';

export const handleAdPlayerScale = enable => {
  const videoEl = document.querySelector('.ads-container>video');
  if (!videoEl) return;
  const fullWidth = SCREEN_WIDTH[getScreenSize()];
  const fullHeight = SCREEN_HEIGHT[getScreenSize()];
  if (enable) {
    const width = Math.floor(fullWidth * (1 - getLBannerWidthScale()));
    const height = Math.floor(fullHeight * (1 - getLBannerHeightScale()));
    videoEl.style.width = `${width}px`;
    videoEl.style.height = `${height}px`;
  } else {
    videoEl.style.width = `${fullWidth}px`;
    videoEl.style.height = `${fullHeight}px`;
  }
};
